import _classCallCheck from "/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { isWalletConnectSession, getLocal, setLocal, removeLocal } from "@walletconnect/utils";

var SessionStorage =
/*#__PURE__*/
function () {
  function SessionStorage() {
    var storageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "walletconnect";

    _classCallCheck(this, SessionStorage);

    this.storageId = storageId;
  }

  _createClass(SessionStorage, [{
    key: "getSession",
    value: function getSession() {
      var session = null;
      var json = getLocal(this.storageId);

      if (json && isWalletConnectSession(json)) {
        session = json;
      }

      return session;
    }
  }, {
    key: "setSession",
    value: function setSession(session) {
      setLocal(this.storageId, session);
      return session;
    }
  }, {
    key: "removeSession",
    value: function removeSession() {
      removeLocal(this.storageId);
    }
  }]);

  return SessionStorage;
}();

export default SessionStorage;